export const state = () => ({
	//
});

export const mutations = {
	//
};

export const getters = {
	//
};

export const actions = {
	create(state: any, payload: any) {
		const { job_uuid, ...data } = payload;

		return new Promise((resolve, reject) => {
			this.$axios
				.post(`api/jobs/${job_uuid}/publishing-schedule`, data)
				.then((res) => {
					state.commit('jobs/single/setJobPost', res.data, { root: true });
					resolve(res.data);
				})
				.catch((err) => reject(err));
		});
	},

	update(state: any, payload: any) {
		const { schedule_uuid, ...data } = payload;

		return new Promise((resolve, reject) => {
			this.$axios
				.put(`/api/jobs/publishing-schedules/${schedule_uuid}`, data)
				.then((res) => {
					state.commit('jobs/single/setJobPost', res.data, { root: true });
					resolve(res.data);
				})
				.catch((err) => reject(err));
		});
	},

	delete(state: any, schedule_uuid: string) {
		return new Promise((resolve, reject) => {
			this.$axios
				.delete(`/api/jobs/publishing-schedules/${schedule_uuid}`)
				.then((res) => {
					state.commit('jobs/single/setJobPost', res.data, { root: true });
					resolve(res.data);
				})
				.catch((err) => reject(err));
		});
	},
};
